export default "__VITE_ASSET__DBEeOkDo__"